module.exports = {
	"base": {
		"welcome": "Welkom bij Mulligans, %{name}!",
		"user": "Gebruikersinformatie",
		"devices": "Apparaten",
		"refunds": "Restituties",
		"resources": "Bronnen",
		"transactions": "Beställningar & Returer",
		"email": "E-mailadres",
		"password": "Wachtwoord",
		"save": "Opslaan",
		"sign-out": "Afmelden",
		"cancel": "Annuleren",
		"close": "Sluit",
		"learn-more": "Meer informatie",
		"required": "Vereist",
		"support": "Ondersteuning",
		"bookshelf": "Bookshelf",
		"launch": "Starten",
		"download": "Download",
		"details": "Gegevens",
		"cannot-be-blank": "%{field} mag niet leeg zijn.",
		"saving": "Opslaan...",
		"done": "Gereed",
		"failed": "Mislukt",
		"copy": "Kopieer"
	},
	"signin": {
		"login-failure": "E-mailadres of wachtwoord is onjuist",
		"welcome-large": "Welkom bij het <span class='inner'>Account Center van %{brand}</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Aanmelden",
		"forgot-password": "Wachtwoord vergeten",
		"new-to-vst": "Nieuw bij %{brand}?",
		"create-account": "Een account maken",
		"signing-in": "Aanmelden...",
		"signin-failed": "Aanmelden mislukt"
	},
	"transactions": {
		"price": "Prijs",
		"excluded": "(exclusief btw)",
		"quantity": "Hoeveelheid",
		"confirmation#": "Bevestiging #",
		"payment": "Betaling",
		"purchased": "Aangeschaft",
		"purchase-details": "Aankoopgegevens",
		"subtotal": "Subtotaal",
		"total": "Totaal",
		"tax": "Belasting",
		"loading": "We laden uw transacties...",
		"no-purchases": "U hebt geen aankopen.",
		"seller-vat": "BTW verkoper",
		"total-vat": "Totaal betaalde %{vat}",
		"portion": "%{subTax} Tax %{rate}%",
		"vat-disclosure": "Prijs is inclusief %{vat}",
		"purchases": "Aankopen",
		"refunded-items": "Gerestitueerde items",
		"book-title": "Boektitel",
		"refund-details": "Informatie over restitutie",
		"print-receipt": "Ontvangstbewijs afdrukken",
		"request-refund": "Restitutie aanvragen",
		"expired": "Verlopen",
		"expires-in": "Verloopt op %{date}",
		"details-refund": "Details en terugbetaling",
		"modal": {
			"cant-refund-title": "Restitutie is niet beschikbaar",
			"cant-refund": "Uw boek kan vanwege een of meer van de volgende redenen niet worden gerestitueerd.",
			"cant-refund-1": "U hebt al een te groot deel van uw boek bekeken.",
			"cant-refund-2": "De aankoopdatum is al langer dan 14 dagen geleden.",
			"cant-refund-3": "Uw online broncode is al getoond.",
			"cant-refund-4": "Uw boek is reeds gerestitueerd.",
			"cant-refund-5": "Alle codes zijn al ingewisseld en/of gerestitueerd.",
			"cant-refund-6": "De aankoopdatum is al langer dan 30 dagen geleden.",
			"cant-refund-support": "Als u nog vragen hebt over het restitutiebeleid van %{brand}, neem dan contact op met <a href='%{support_url}' target='_blank'>ondersteuning</a>."
		},
		"license": {
			"perpetual": "Online toegang verloopt niet",
			"days": "%{days} dag(en) toegang"
		}
	},
	"devices": {
		"description": "Met %{brand} kunnen <span>%{desktop}</span> computers en <span>%{mobile}</span> mobiele apparaten of tablets tegelijk geactiveerd zijn.",
		"loading": "We laden uw apparaten.",
		"no-active": "U hebt geen actieve apparaten.",
		"deactivate": "Deactiveren"
	},
	"user": {
		"personal-information": "Persoonlijke gegevens",
		"security-information": "Beveiligingsinformatie",
		"notifications": "Meldingen",
		"first-name": "Voornaam",
		"last-name": "Achternaam",
		"change-password-title": "Wachtwoord wijzigen",
		"current-password": "Huidig wachtwoord",
		"new-password": "Nieuw wachtwoord",
		"security-password": "Wachtwoord",
		"confirm-new-password": "Nieuw wachtwoord bevestigen",
		"security-question": "Beveiligingsvraag",
		"security-info-change": "Wijzigen",
		"question": "Vraag",
		"answer": "Antwoord",
		"notifications-text": "Stuur mij incidenteel updates per e-mail over mijn accountactiviteit, productupdates en speciale aanbiedingen.",
		"loading": "Spot haalt uw gebruikersinformatie op, een moment geduld 🐶",
		"change-password-text": "Wachtwoorden moeten ten minste acht tekens, een hoofdletter, een kleine letter en een speciaal teken bevatten.",
		"email-locked": "E-mail vergrendeld",
		"email-locked-description": "U hebt geen toegang om uw e-mailadres te wijzigen.",
		"email-locked-more": "Neem contact op met uw beheerder.",
		"security-question6": "Wat is uw favoriete sport?",
		"security-question7": "Welke smaak ijs vindt u het lekkerst?",
		"security-question8": "Hoe heet uw lievelingshuisdier?",
		"security-question9": "Wat wilde u later worden toen u klein was?",
		"security-question10": "Wat is de achternaam van uw favoriete leraar/lerares?",
		"new-password-failure": "Het wachtwoord voldoet niet aan de vereisten.",
		"confirm-password-failure": "Wachtwoord moet overeenkomen",
		"new-password-tooltip": "Moet ten minste acht tekens, een hoofdletter, een kleine letter en een speciaal teken bevatten.",
		"enter-valid-email": "Voer een geldig e-mailadres in.",
		"password-cannot-be-same": "Wachtwoord mag niet hetzelfde zijn als het vorige wachtwoord.",
		"incorrect-password": "Onjuist wachtwoord",
		"complete-account": "Het lijkt erop dat u uw <a href='%{href}'>account moet voltooien</a>.",
		"completing-allows": "Als u uw account voltooit, kunt u offline boeken lezen op onze mobiele apps en notities en markeringen delen met vrienden.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Accessoires",
		"access-codes": "Toegangscodes",
		"print-on-demand": "Afdrukken op aanvraag",
		"check-pod": "Bekijk uitgeversafdrukopties voor uw boeken.",
		"check-now": "Nu controleren",
		"loading": "Een moment geduld, we werken uw bronnen bij.",
		"in": "in",
		"access-code-intro": "Een toegangscode is een wachtwoord waarmee u toegang krijgt tot online cursusmateriaal. Als u een code voor een item hebt getoond, kunt u dit niet meer ruilen. Ga voor meer informatie over het gebruik van uw toegangscode naar <a href='%{support_url}' target='_blank'>Ondersteuning</a>.",
		"expires": "Verloopt",
		"expiration-message": "Bevat informatie voor het gebruik van uw toegangscode.",
		"copy-fail": "Kan niet worden gekopieerd. Selecteer de code en kopieer deze handmatig.",
		"launch-site": "Site starten",
		"launch-book": "Boek openen",
		"reveal-code": "Code tonen",
		"no-resources": "U hebt geen bronnen.",
		"no-access-codes": "U hebt geen toegangscodes.",
		"no-ancillaries": "Geen accessoires voor deze titel",
		"name": "Naam",
		"type": "Type",
		"size": "Formaat",
		"download-all": "Alles downloaden",
		"back": "Terug naar bronnen"
	},
	"refunds": {
		"states": {
			"refunded": "Gerestitueerd",
			"unavailable": "Restitutie niet beschikbaar"
		},
		"reasons": {
			"dropped": "Ik ben gestopt met de cursus.",
			"wrong": "Dit boek hoort niet bij mijn cursus.",
			"print": "Ik heb een papieren versie gekocht.",
			"missing": "Het boek bevat niet alles wat ik nodig heb voor mijn cursus ( zoals een cd, webtoegang, video's).",
			"other": "Anders"
		},
		"bulk": {
			"policy": "Door hieronder op de knop 'Restitutie voltooien' te klikken, ga ik akkoord met het <a href='%{policy_url}' target='_blank'>restitutiebeleid</a> van %{brand}.",
			"complete": "Restitutie voltooien",
			"view-details": "Restitutiegegevens bekijken",
			"success": "Je terugbetaling is aangevraagd. De verwerking kan 48 uur duren.",
			"failure": "Oeps, er is iets fout gegaan. Uw restitutie is helaas niet verwerkt.",
			"retry": "Opnieuw proberen",
			"support": "Contact opnemen met technische ondersteuning",
			"available-codes": "Beschikbare codes",
			"codes-selected": "Geselecteerde codes",
			"download": "Codes downloaden",
			"partially-refunded": "Deels gerestitueerd",
			"pick-one": "U moet ten minste één code selecteren om een restitutie te geven."
		},
		"refund": "Restitueren",
		"all": "Alles restitueren?",
		"missing-reason": "U moet een reden selecteren om verder te gaan.",
		"missing-elaboration": "Geef de benodigde uitleg",
		"policy": "Door hieronder op de knop 'Restitutieaanvraag voltooien' te klikken, geef ik aan dat ik begrijp dat als ik dit eTextbook van %{brand} aanschaf, ik hierna verder geen restituties meer voor hetzelfde eTextbook kan aanvragen. Bekijk het volledige restitutiebeleid.",
		"refunded": "Gerestitueerd",
		"sorry": "We vinden het jammer dat u niet tevreden bent met uw aankoop.",
		"error": "Er is iets misgegaan. ",
		"error-explain": "We konden uw restitutie niet verwerken. Probeer het opnieuw.",
		"why": "Vertel ons waarom.",
		"no-refunds": "U hebt geen gerestitueerde items.",
		"select-codes": "Selecteer code(s) om te restitueren:",
		"number": "Hoeveel?",
		"back": "Terug naar restituties"
	},
	"purchases": {
		"back": "Terug naar aankopen"
	},
	"global-bar": {
		"account": "Accountinstellingen"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/nl.json
 ** module id = 1016
 ** module chunks = 0
 **/